import { ProspectUpdatedAtBucketEnum } from '@shared/interfaces-enums';

/**
 * Tranches API à charger selon l’état de la case « + de 18 mois » (UI uniquement).
 * recent = MAJ dans les 2 derniers mois ; mid = entre 2 et 18 mois ; stale = 18 mois et plus.
 * Équivalent : recent+mid ≈ ancien is18month=false ; +stale ≈ is18month=true.
 */
export function getProspectFetchBuckets(includeStale: boolean): ProspectUpdatedAtBucketEnum[] {
  const buckets: ProspectUpdatedAtBucketEnum[] = [
    ProspectUpdatedAtBucketEnum.recent,
    ProspectUpdatedAtBucketEnum.mid
  ];
  if (includeStale) {
    buckets.push(ProspectUpdatedAtBucketEnum.stale);
  }
  return buckets;
}

/**
 * Détermine si un prospect est considéré « stale » (dernière mise à jour > 18 mois).
 *
 * @param updatedAt - Date de dernière mise à jour du prospect.
 * @returns `true` si le prospect n'a pas été mis à jour depuis plus de 18 mois.
 */
export function isProspectStaleByUpdatedAt(updatedAt: Date | string | undefined): boolean {
  if (!updatedAt) {
    return false;
  }
  const eighteenMonthsAgo = new Date();
  eighteenMonthsAgo.setMonth(eighteenMonthsAgo.getMonth() - 18);
  return new Date(updatedAt) <= eighteenMonthsAgo;
}
